<template>
  <div class="animated fadeIn">
    <!-- Start Tab Body -->
    <div v-if="loadingTab && !loading" class="center-block">
      <div class="circle-loading mb-2"></div>
      <p style="color: var(--turquoise)">Đang tải dữ liệu ...</p>
    </div>
    <div
      v-if="tab != 'DOC_ORGANIZATIONMODEL' && (!loadingTab || loading)"
      class="infinite-list-wrapper"
      id="infinite__scroll"
    >
      <ul
        class="list p-0"
        v-infinite-scroll="load"
        :infinite-scroll-disabled="disabled"
      >
        <li v-for="(doc, i) in fn_dynamicData()" :key="i" class="list-item" :id="i">
          <el-card shadow="hover">
            <div
              slot="header"
              class="d-flex align-items-baseline"
              @click="fn_goToDetail(doc.id, tab)"
            >
              <span
                class="mr-2 order"
                :class="fn_checkRead(doc) ? 'readed' : 'unread'"
              >
                {{ i + 1 }}
              </span>
              <span
                :class="fn_checkRead(doc) ? 'readed' : 'unread'"
                class="doc__header-name"
                :title="doc.name ? doc.name : ''"
                >{{ doc.name ? doc.name : "" }}
              </span>
              <div
                v-if="doc.secret_id && doc.secret_id != 'Bình thường'"
                :class="{
                  'ml-2 secret text-center': true,
                  'top-secret': doc.secret_id == 'Tuyệt mật',
                  private: doc.secret_id == 'Mật',
                }"
              >
                {{ doc.secret_id }}
              </div>
              <div
                v-if="doc.urgency_id && doc.urgency_id != 'Bình thường'"
                :class="{
                  'ml-2 urgency text-center': true,
                  'high-urgency': doc.urgency_id == 'Thượng khẩn',
                  urgent: doc.urgency_id == 'Khẩn',
                  express: doc.urgency_id == 'Hoả Tốc',
                }"
              >
                {{ doc.urgency_id }}
              </div>
              <div
                v-if="checkExpired(doc)"
                :class="{
                  'ml-2 expire text-center': true,
                }"
              >
                Hết hiệu lực
              </div>
            </div>

            <div class="d-flex parent__block">
              <div
                class="first-child__block"
                @click="fn_goToDetail(doc.id, tab)"
              >
                <p
                  :class="{
                    'card__item-content': true,
                    readed: fn_checkRead(doc),
                    unread: !fn_checkRead(doc),
                  }"
                  :title="doc.description ? doc.description : ''"
                >
                  {{ doc.description ? doc.description : "" }}
                </p>
                <div class="card__item-annotate d-flex align-items-center">
                  <p
                    class="text-overflow-custom"
                    :title="
                      doc.document_category_name +
                        ' • ' +
                        doc.business_name +
                        ' • ' +
                        doc.code +
                        ' • ' +
                        doc.book_number +
                        ' • ' +
                        doc.status_name
                    "
                  >
                    {{ doc.document_category_name }} • {{ doc.business_name }} •
                    {{ doc.code }} •
                    {{ doc.book_number }}
                    <span v-if="doc.other_files && doc.other_files.length > 0"
                      >• <i class="fal fa-paperclip"></i
                    ></span>
                    •
                    {{ doc.status_name }}
                    <!-- Start Status for other company Block -->
                    <span
                      v-if="
                        (doc.status == 'SIGNED' || doc.status == 'PUBLISHED') &&
                        doc.transfer_to_companies &&
                        doc.transfer_to_companies.length > 0 &&
                        doc.transfer_to_companies[
                          doc.transfer_to_companies.length - 1
                        ].status == 'SIGNED'
                      "
                      class="c-turquoise"
                      title="Đối tác đã ký duyệt"
                    >
                      • Đối tác đã ký duyệt
                    </span>
                    <span
                      v-if="
                        (doc.status == 'SIGNED' || doc.status == 'PUBLISHED') &&
                        doc.transfer_to_companies &&
                        doc.transfer_to_companies.length > 0 &&
                        doc.transfer_to_companies[
                          doc.transfer_to_companies.length - 1
                        ].status == 'REJECTED'
                      "
                      class="c-red"
                      title="Đối tác đã từ chối"
                    >
                      • Đối tác đã từ chối
                    </span>
                    <!-- End Status for other company Block -->
                  </p>
                </div>
              </div>
              <div
                class="second-child__block"
                @click="fn_goToDetail(doc.id, tab)"
              >
                <p
                  class="signer"
                  :title="doc.listSigner ? doc.listSigner : 'Không xác định'"
                >
                  Người ký:
                  {{ doc.listSigner ? doc.listSigner : "Không xác định" }}
                </p>
                <p
                  class="creator"
                  :title="
                    doc.creator_name ? doc.creator_name : 'Không xác định'
                  "
                >
                  Người tạo:
                  {{ doc.creator_name ? doc.creator_name : "Không xác định" }}
                </p>
              </div>
              <div
                class="third-child__block"
                @click="fn_goToDetail(doc.id, tab)"
              >
                <p
                  class="promulgate"
                  :title="
                    doc.publish && doc.publish.publish_at
                      ? fn_formatDate(doc.publish.publish_at)
                      : '--/--/--'
                  "
                >
                  Ban hành:
                  {{
                    doc.publish && doc.publish.publish_at
                      ? fn_formatDate(doc.publish.publish_at)
                      : "--/--/--"
                  }}
                </p>
                <p
                  class="processing-term"
                  :title="fn_showDeadlineManipulately(doc)"
                >
                  Hạn xử lý:
                  {{ fn_showDeadlineManipulately(doc) }}
                </p>
              </div>
              <div
                class="four-child__block 67"
                @click="
                  tab == 'DOC_SIGN_CONSENT'
                    ? fn_goToTempSign(doc.id, doc.name)
                    : tab == 'DOC_IN' ||
                      tab == 'DOC_OUT' ||
                      tab == 'DOC_ISSUE'
                        ? fn_goToTransfer(doc.id, doc.name)
                        : (tab == 'FILTER' || tab == 'DOC_SIGN') && doc.status == 'NEW'
                          ? fn_deleteDocument(doc.id, doc.name, i)
                          : fn_goToDetail(doc.id, tab)
                "
              >
                <i
                  v-if="
                    tab == 'DOC_IN' ||
                    tab == 'DOC_OUT' ||
                    tab == 'DOC_SIGN_CONSENT' ||
                    tab == 'DOC_ISSUE'
                  "
                  class="icon icon24-Foward mr-2"
                  :title="
                    tab == 'DOC_SIGN_CONSENT'
                      ? 'Yêu cầu ký nháy'
                      : 'Chuyển tiếp văn bản'
                  "
                ></i>
                <i
                  v-if="(tab == 'FILTER' || tab == 'DOC_SIGN') && doc.status == 'NEW'"
                  class="icon icon24-Delete mr-2"
                  title="Xóa văn bản"
                ></i>
              </div>
            </div>
          </el-card>
        </li>
      </ul>
      <div v-if="loading" class="text-center pb-4">
        <div class="circle-loading mb-2"></div>
        <p style="color: var(--turquoise)">Đang tải dữ liệu ...</p>
      </div>
    </div>
    <div
      v-if="tab == 'DOC_ORGANIZATIONMODEL' && (!loadingTab || loading)"
      class="infinite-list-wrapper"
    >
      <el-tree
        :data="mData.dataDefault.listOrganizationModelTree"
        default-expand-all
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps"
      >
      </el-tree>
    </div>
  </div>
</template>

<script>
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DocumentApi from "../../../moduleApi/DocumentApi";
import OrganizationModelApi from "../../../moduleApi/OrganizationModelApi";
import { dataDocMixins } from "./DocumentMixins/dataDocMixins";
import { fnDocMixins } from "./DocumentMixins/fnDocMixins";
import { Filter, Sort } from "mushroomjs";
export default {
  mixins: [dataDocMixins, fnDocMixins],
  props: {
    tab: {
      type: String,
      default: "",
    },
    listDocumentType: {
      type: Array,
      default: () => [],
    },
    listEmployee: {
      type: Array,
      default: () => [],
    },
    listDocumentBusiness: {
      type: Array,
      default: () => [],
    },
    filtersDocument: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogRecall: false,

      loading: false,
      countDocFilter: 10,
      countDocIn: 10,
      countDocOut: 10,
      countDocSign: 10,
      countDocSignConsent: 10,
      countDocSignTemp: 10,
      countDocIssue: 10,

      listDocumentFilterTotal: 0,
      listDocumentInTotal: 0,
      listDocumentOutTotal: 0,
      listDocumentSignTotal: 0,
      listDocumentSignConsentTotal: 0,
      listDocumentSignTempTotal: 0,
      listDocumentIssueTotal: 0,

      docFilterOffset: 0,
      docInOffset: 0,
      docOutOffset: 0,
      docSignOffset: 0,
      docSignConsentOffset: 0,
      docSignTempOffset: 0,
      docIssueOffset: 0,
      dataSearch: {},
      loadingTab: false,

      defaultProps: {
        children: "children",
        label: "label",
      },
      checkLoading: 0,
      limitAfterDelete: 0
    };
  },
  computed: {
    noMore() {
      if (this.tab == "FILTER") {
        return this.countDocFilter >= this.listDocumentFilterTotal;
      } else if (this.tab == "DOC_IN") {
        return this.countDocIn >= this.listDocumentInTotal;
      } else if (this.tab == "DOC_OUT") {
        return this.countDocOut >= this.listDocumentOutTotal;
      } else if (this.tab == "DOC_SIGN") {
        return this.countDocSign >= this.listDocumentSignTotal;
      } else if (this.tab == "DOC_SIGN_CONSENT") {
        return this.countDocSignConsent >= this.listDocumentSignConsentTotal;
      } else if (this.tab == "DOC_SIGN_TEMP") {
        return this.countDocSignTemp >= this.listDocumentSignTempTotal;
      } else if (this.tab == "DOC_ISSUE") {
        return this.countDocIssue >= this.listDocumentIssueTotal;
      }
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  methods: {
    checkExpired(doc) {
      if (doc.effected_date && doc.effected_date.end_effected_at) {
        return new Date().getTime() > new Date(doc.effected_date.end_effected_at).getTime()
      } else {
        return false;
      }
    },

    fn_checkRead(doc) {
      if (!doc.readers) {
        return false;
      }
      const hadRead = doc.readers.find(
        (person) => person.employee_id == this.mData.currentUser.id
      );
      return hadRead ? true : false;
    },

    load() {
      this.loading = true;
      setTimeout(async () => {
        if (this.tab == "FILTER") {
          this.countDocFilter += 10;
          this.docFilterOffset += 10;
          this.listDocumentFilterTotal += 10;
          await this.fn_getListDocumentFilter();
        } else if (this.tab == "DOC_IN") {
          this.countDocIn += 10;
          this.docInOffset += 10;
          this.listDocumentInTotal += 10;
          await this.fn_getListDocumentIn();
        } else if (this.tab == "DOC_OUT") {
          this.countDocOut += 10;
          this.docOutOffset += 10;
          this.listDocumentOutTotal += 10;
          await this.fn_getListDocumentOut();
        } else if (this.tab == "DOC_SIGN") {
          this.countDocSign += 10;
          this.docSignOffset += 10;
          this.listDocumentSignTotal += 10;
          await this.fn_getListDocumentSign();
        } else if (this.tab == "DOC_SIGN_CONSENT") {
          this.countDocSignConsent += 10;
          this.docSignConsentOffset += 10;
          this.listDocumentSignConsentTotal += 10;
          await this.fn_getListDocumentSignConsent();
        } else if (this.tab == "DOC_SIGN_TEMP") {
          this.countDocSignTemp += 10;
          this.docSignTempOffset += 10;
          this.listDocumentSignTempTotal += 10;
          await this.fn_getListDocumentSignTemp();
        } else if (this.tab == "DOC_ISSUE") {
          this.countDocIssue += 10;
          this.docIssueOffset += 10;
          this.listDocumentIssueTotal += 10;
          await this.fn_getListDocumentIssue();
        }
        this.loading = false;
      }, 500);
    },

    fn_dynamicData() {
      if (this.tab == "FILTER") {
        return this.listDocumentFilter;
      } else if (this.tab == "DOC_IN") {
        return this.listDocumentIn;
      } else if (this.tab == "DOC_OUT") {
        return this.listDocumentOut;
      } else if (this.tab == "DOC_SIGN") {
        return this.listDocumentSign;
      } else if (this.tab == "DOC_SIGN_CONSENT") {
        return this.listDocumentSignConsent;
      } else if (this.tab == "DOC_SIGN_TEMP") {
        return this.listDocumentSignTemp;
      } else if (this.tab == "DOC_ISSUE") {
        return this.listDocumentIssue;
      }
    },

    fn_showDeadlineManipulately(doc) {
      let deadlineTemp = "";
      if (this.tab == "DOC_SIGN_TEMP") {
        const waitingSigner = doc.signers.find(
          (signer) => signer.status == "WAITING"
        );
        if (
          waitingSigner &&
          waitingSigner.request_temp_signers &&
          waitingSigner.request_temp_signers.length > 0
        ) {
          const tempSigner = waitingSigner.request_temp_signers.find(
            (tempSigner) => tempSigner.user_id == this.mData.currentUser.id
          );
          deadlineTemp = tempSigner ? tempSigner.deadline : "";
        }
      }
      return (this.tab == "DOC_SIGN_CONSENT" && doc.deadline) ||
        (this.tab == "DOC_SIGN" && doc.deadline) ||
        (this.tab == "DOC_IN" && doc.deadline) ||
        (this.tab == "DOC_OUT" && doc.deadline)
        ? this.fn_formatDate(doc.deadline)
        : this.tab == "DOC_SIGN_TEMP" && deadlineTemp
        ? this.fn_formatDate(deadlineTemp)
        : "--/--/--";
    },

    async fn_getListDocumentFilter() {
      this.loadingTab = true;
      this.dataSearch.limit = this.mData.tableRules.limit;
      this.dataSearch.skip = this.docFilterOffset;

      if (
        this.dataSearch.include_word_find &&
        typeof this.dataSearch.include_word_find == "string"
      ) {
        this.dataSearch.include_words = MethodService.changeAlias(
          this.dataSearch.include_word_find
        )
          .toLowerCase()
          .split(" ");
      }
      if (
        this.dataSearch.exclude_word_find &&
        typeof this.dataSearch.exclude_word_find == "string"
      ) {
        this.dataSearch.exclude_words = MethodService.changeAlias(
          this.dataSearch.exclude_word_find
        )
          .toLowerCase()
          .split(" ");
      }
      if (typeof this.dataSearch.include_words == "string") {
        this.dataSearch.include_words = [];
      }
      if (typeof this.dataSearch.exclude_words == "string") {
        this.dataSearch.exclude_words = [];
      }
      let dataFilter = this.dataSearch;
      const documentInApiRes = await DocumentApi.SearchDocument(dataFilter);
      if (
        documentInApiRes.result &&
        documentInApiRes.result.result &&
        documentInApiRes.result.result.length > 0
      ) {
        const o = await this.fn_changeDataDoc(documentInApiRes.result.result);
        this.listDocumentFilter = [...this.listDocumentFilter, ...o];
        this.listDocumentFilterTotal = documentInApiRes.meta.total;
      } else {
        this.listDocumentFilter = [];
      }
      this.loadingTab = false;
    },

    async fn_getListDocumentIn() {
      this.loadingTab = true;
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      const filter = Filter.or(
        Filter.and(
          Filter.eq("company_id", "$$user_company_id"),
          Filter.eq("publish.publisher_to_ids", "$$user_id"),
          Filter.eq("status", "PUBLISHED")
        ),
        Filter.and(
          Filter.eq("company_id", "$$user_company_id"),
          Filter.eq("signers.user_id", "$$user_id"),
          Filter.eq("status", "PUBLISHED")
        ),
        Filter.and(
          Filter.eq("company_id", "$$user_company_id"),
          Filter.elementMatch("signers", [
            Filter.eq("user_id", "$$user_id"),
            Filter.eq("status", "SIGNED"),
          ]),
          Filter.eq("status", "WAITING_FOR_SIGN")
        ),
        Filter.and(
          Filter.eq("company_id", "$$user_company_id"),
          Filter.eq("signers.user_id", "$$user_id"),
          Filter.eq("status", "SIGNED")
        ),
        Filter.and(
          Filter.eq("company_id", "$$user_company_id"),
          Filter.eq("signers.user_id", "$$user_id"),
          Filter.eq("status", "RECALLED")
        ),
        Filter.and(
          Filter.eq("company_id", "$$user_company_id"),
          Filter.eq("signers.user_id", "$$user_id"),
          Filter.eq("status", "TRANSFERED_OTHER_COMPANY")
        ),
        Filter.and(
          Filter.eq("company_id", "$$user_company_id"),
          Filter.eq("transfer.person_ids", "$$user_id"),
          Filter.in("status", ["PUBLISHED", "SIGNED", "TRANSFERED_OTHER_COMPANY"])
        ),
      ).build();

      dataFilter.filters = filter;
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.docInOffset;
      }
      const documentInApiRes = await DocumentApi.list(dataFilter);
      if (documentInApiRes.result && documentInApiRes.result.length > 0) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;

        const o = await this.fn_changeDataDoc(documentInApiRes.result);
        this.listDocumentIn = [...this.listDocumentIn, ...o];
        this.listDocumentInTotal = documentInApiRes.meta.total;
      } else {
        this.listDocumentIn = [];
      }
      this.loadingTab = false;
    },

    async fn_getListDocumentOut() {
      this.loadingTab = true;
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      const filter = Filter.and(
        Filter.eq("company_id", "$$user_company_id"),
        Filter.eq("author_id", "$$user_id"),
        Filter.in("status", ["SIGNED","PUBLISHED","RECALLED","TRANSFERED_OTHER_COMPANY"]),
      ).build();

      dataFilter.filters = filter;
      // dataFilter.filters += `company_id=$$user_company_id&author_id=$$user_id&status:in:SIGNED,PUBLISHED,RECALLED,TRANSFERED_OTHER_COMPANY`;

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.docOutOffset;
      }
      const documentInApiRes = await DocumentApi.list(dataFilter);
      if (documentInApiRes.result && documentInApiRes.result.length > 0) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;

        const o = await this.fn_changeDataDoc(documentInApiRes.result);
        this.listDocumentOut = [...this.listDocumentOut, ...o];
        this.listDocumentOutTotal = documentInApiRes.meta.total;
      } else {
        this.listDocumentOut = [];
      }
      this.loadingTab = false;
    },

    async fn_getListDocumentSign(isDelete) {
      this.loadingTab = true;
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      const filter = Filter.and(
        Filter.eq("company_id", "$$user_company_id"),
        Filter.eq("author_id", "$$user_id"),
        Filter.in("status", ["NEW","WAITING_FOR_SIGN","REJECT_FOR_SIGN","REJECTED"]),
      ).build();

      dataFilter.filters = filter;
      // dataFilter.filters += `company_id=$$user_company_id&author_id=$$user_id&status:in:NEW,WAITING_FOR_SIGN,REJECT_FOR_SIGN,REJECTED`;

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = isDelete ? this.limitAfterDelete : this.mData.tableRules.limit;
        dataFilter.offset = isDelete ? 0 : this.docSignOffset;
      }
      const documentInApiRes = await DocumentApi.list(dataFilter);
      if (documentInApiRes.result && documentInApiRes.result.length > 0) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;

        const o = await this.fn_changeDataDoc(documentInApiRes.result);
        this.listDocumentSign = [...this.listDocumentSign, ...o];
        this.listDocumentSignTotal = documentInApiRes.meta.total;
      } else {
        // this.listDocumentSign = [];
      }
      this.loadingTab = false;
    },

    async fn_getListDocumentSignConsent() {
      this.loadingTab = true;
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      const filter = Filter.and(
        Filter.eq("company_id", "$$user_company_id"),
        Filter.eq("status", "WAITING_FOR_SIGN"),
        Filter.elementMatch("signers", [
          Filter.eq("user_id", "$$user_id"),
          Filter.eq("status", "WAITING"),
        ]),
      ).build();

      dataFilter.filters = filter;

      // dataFilter.filters += `company_id=$$user_company_id&status=WAITING_FOR_SIGN&signers:elemMatch:user_id=$$user_id,status=WAITING`;

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.docSignConsentOffset;
      }
      const documentInApiRes = await DocumentApi.list(dataFilter);
      if (documentInApiRes.result && documentInApiRes.result.length > 0) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;

        const o = await this.fn_changeDataDoc(documentInApiRes.result);
        this.listDocumentSignConsent = [...this.listDocumentSignConsent, ...o];
        this.listDocumentSignConsentTotal = documentInApiRes.meta.total;
      } else {
        this.listDocumentSignConsent = [];
      }
      this.loadingTab = false;
    },

    async fn_getListDocumentSignTemp() {
      this.loadingTab = true;
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      const filter = Filter.and(
        Filter.eq("company_id", "$$user_company_id"),
        Filter.eq("status", "WAITING_FOR_SIGN"),
        Filter.elementMatch("signers", [
          Filter.eq("status", "WAITING"),
          Filter.elementMatch("request_temp_signers", [
            Filter.eq("user_id", "$$user_id"),
            Filter.eq("status", "NEW"),
          ])
        ]),
      ).build();

      dataFilter.filters = filter;

      // dataFilter.filters += `company_id=$$user_company_id&status=WAITING_FOR_SIGN&signers:elemMatch:status=WAITING,request_temp_signers:elemMatch:user_id=$$user_id\\,status=NEW`;

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.docSignTempOffset;
      }
      const documentInApiRes = await DocumentApi.list(dataFilter);
      if (documentInApiRes.result && documentInApiRes.result.length > 0) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;

        const o = await this.fn_changeDataDoc(documentInApiRes.result);
        this.listDocumentSignTemp = [...this.listDocumentSignTemp, ...o];
        this.listDocumentSignTempTotal = documentInApiRes.meta.total;
      } else {
        this.listDocumentSignTemp = [];
      }
      this.loadingTab = false;
    },

    async fn_getListDocumentIssue() {
      const filter = Filter.and(
        Filter.eq("company_id", "$$user_company_id"),
        Filter.eq("publish.is_auto", false),
        Filter.or(
          Filter.eq("status", "SIGNED"),
          Filter.eq("status", "RECALLED"),
          Filter.eq("status", "PUBLISHED")
        )
      ).build();
      const sort = Sort.descending("status")
        .thenByDescending("created_at")
        .build(); // x,y
      this.loadingTab = true;
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        sort: sort,
      };

      dataFilter.filters += this.mData.tableRules.filters
        ? `&${filter}`
        : `${filter}`;

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.docIssueOffset;
      }
      const documentInApiRes = await DocumentApi.list(dataFilter);
      if (documentInApiRes.result && documentInApiRes.result.length > 0) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;

        const o = await this.fn_changeDataDoc(documentInApiRes.result);
        this.listDocumentIssue = [...this.listDocumentIssue, ...o];
        this.listDocumentIssueTotal = documentInApiRes.meta.total;
      } else {
        this.listDocumentIssue = [];
      }
      this.loadingTab = false;
    },

    fn_changeDataDoc(data) {
      data.forEach((doc) => {
        this.fn_checkHasSign(doc);
        this.fn_matchAuthorName(doc);
        this.fn_matchCreatorName(doc);
        this.fn_matchDocCategoryName(doc);
        doc.secret_id = doc.secret_id ? doc.secret_id : "";
        doc.urgency_id = doc.urgency_id ? doc.urgency_id : "";
        this.fn_matchSignerList(doc);
        this.fn_matchBusinessName(doc);
        this.fn_setStatusDoc(doc);
      });
      return data;
    },

    fn_matchAuthorName(doc) {
      if (doc.author_id) {
        const o = this.listEmployee.find((emp) => emp.id == doc.author_id);
        doc.author_name =
          o && o.administrative_info
            ? o.administrative_info.name.full_name
            : this.mData.currentCompany.name.name_vi;
      }
    },

    fn_matchCreatorName(doc) {
      if (doc.creator_id) {
        const o = this.listEmployee.find((emp) => emp.id == doc.creator_id);
        doc.creator_name =
          doc.ref_id &&
          doc.histories &&
          doc.histories.length > 0 &&
          doc.histories[0].from_company_info &&
          doc.histories[0].from_company_info.name
            ? doc.histories[0].from_company_info.name
            : o && o.administrative_info
            ? o.administrative_info.name.full_name
            : this.mData.currentCompany.name.name_vi;
      }
    },

    fn_matchDocCategoryName(doc) {
      if (doc.document_category_id) {
        const o = this.listDocumentType.find(
          (el) => el.id == doc.document_category_id
        );
        doc.document_category_name = o ? o.name : "";
      }
    },

    fn_matchSignerList(doc) {
      if (doc.signers && doc.signers.length > 0) {
        let listSigner = [];
        doc.signers.forEach((signer) => {
          const o = this.listEmployee.find((emp) => emp.id == signer.user_id);
          doc.user_name = o ? o.administrative_info.name.full_name : "";
          listSigner.push(doc.user_name);
        });
        doc.listSigner = listSigner.join(", ");
      }
    },

    fn_matchBusinessName(doc) {
      if (doc.business_id) {
        const o = this.listDocumentBusiness.find(
          (business) => business.id == doc.business_id
        );
        doc.business_name = o ? o.name : "Không xác định";
      }
    },

    fn_setStatusDoc(doc) {
      // Check trạng thái văn bản
      if (doc.status === "NEW") {
          doc.status_name = "Mới";
        } else if (
          // (doc.status === "WAITING_FOR_SIGN" && this.isRejectTempSigned && this.tab === "DOC_SIGN_TEMP") ||
          this.tab == "FILTER" &&
          this.dataSearch.status == "DOC_DRAFF_REJECTED"
        ) {
          doc.status_name = "Đã từ chối ký nháy";
        } else if (doc.status === "REJECT_FOR_SIGN") {
          doc.status_name = "Đã hủy trình ký";
        } else if (
          doc.status === "REJECTED" &&
          this.dataSearch &&
          this.dataSearch.status !== "DOC_SIGNED"
        ) {
          doc.status_name = "Đã từ chối";
        } else if (
          doc.status === "WAITING_FOR_SIGN" &&
          (this.tab === "DOC_SIGN_TEMP" ||
            (this.tab == "FILTER" &&
              (this.dataSearch.status == "DOC_DRAFF_WAITING" ||
                this.dataSearch.type == "N")))
        ) {
          doc.status_name = "Chờ ký nháy";
        } else if (
          doc.status === "WAITING_FOR_SIGN" &&
          ((doc.author_id === this.mData.currentUser.id &&
            this.tab != "FILTER") ||
            (this.tab == "FILTER" &&
              this.dataSearch.status !== "DOC_SIGNED" &&
              this.dataSearch.status !== "DOC_DRAFF_SIGNED"))
        ) {
          doc.status_name = "Đang chờ ký";
        } else if (
          doc.status === "WAITING_FOR_SIGN" &&
          doc.author_id !== this.mData.currentUser.id &&
          ((this.tab !== "DOC_SIGN_TEMP" && this.tab !== "FILTER") ||
            (this.tab == "FILTER" && this.dataSearch.status == "DOC_WAITING") ||
            (this.tab == "FILTER" &&
              this.dataSearch.status !== "DOC_DRAFF_SIGNED"))
        ) {
          doc.status_name = "Chờ ký duyệt";
        } else if (
          (doc.status === "WAITING_FOR_SIGN" &&
            this.isTempSigned &&
            this.tab === "DOC_SIGN_TEMP") ||
          (this.tab == "FILTER" && this.dataSearch.status == "DOC_DRAFF_SIGNED")
        ) {
          doc.status_name = "Đã ký nháy";
        } else if (
          (doc.status == "SIGNED" && doc.is_signed && this.tab !== "FILTER") ||
          (doc.status == "WAITING_FOR_SIGN" &&
            doc.is_signed &&
            this.tab !== "FILTER") ||
          (doc.author_id !== this.mData.currentUser.id &&
            doc.status == "PUBLISHED" &&
            doc.is_signed &&
            this.tab !== "DOC_ISSUE" &&
            this.tab !== "FILTER") ||
          (doc.status == "RECALLED" &&
            doc.is_signed &&
            this.tab !== "DOC_ISSUE" &&
            this.tab !== "FILTER") ||
          (this.tab == "FILTER" && this.dataSearch.status == "DOC_SIGNED")
        ) {
          doc.status_name = "Đã ký duyệt";
        } else if (doc.status === "SIGNED") {
          doc.status_name = "Đã ký duyệt";
        } else if (
          (doc.status == "PUBLISHED" &&
            (doc.author_id == this.mData.currentUser.id ||
              this.tab == "DOC_ISSUE" ||
              doc.status == "PUBLISHED")) ||
          (doc.status == "PUBLISHED" &&
            this.tab == "FILTER" &&
            this.dataSearch.status == "DOC_PUBLISHED")
        ) {
          doc.status_name = "Đã ban hành";
        } else if (doc.status === "RECALLED") {
          doc.status_name = "Đã thu hồi";
        } else if (doc.status === "TRANSFERED_OTHER_COMPANY") {
          doc.status_name = "Chuyển cho công ty khác";
        } else {
          doc.status_name = "Không xác định";
        }
    },

    fn_checkHasSign(doc) {
      if (doc.signers && doc.signers.length > 0) {
        const objSigner = doc.signers.find(
          (signer) =>
            signer.user_id == this.mData.currentUser.id &&
            signer.status == "SIGNED"
        );
        if (objSigner) {
          doc.is_signed = true;
        } else {
          doc.is_signed = false;
        }
      }
    },

    fn_deleteDocument(docId, docName, index) {
      this.$confirm(`Bạn có chắc chắn muốn xóa văn bản "${docName}" không?`, {
        confirmButtonText: LanguageService.lang.c_agree,
        cancelButtonText: LanguageService.lang.c_cancel,
        type: "warning",
      })
        .then(async () => {
          try {
            const resDelete = await DocumentApi.delete(docId);
            if (resDelete.result > 0) {
              this.$notify.success({
                message: `Xóa văn bản "${docName}" thành công`,
                duration: 3000,
                customClass: "doc-success",
              });
              setTimeout(() => {
                this.$emit('deleteDocument')
                this.limitAfterDelete = this.listDocumentSign.length;
                this.docSignOffset = this.listDocumentSign.length <= 10 ? 0 : this.listDocumentSign.length - 10;
                this.countDocSign = this.listDocumentSign.length;
                this.fn_initDataList(true);
                setTimeout(() => {
                  this.scrollToPosition(index);
                }, 500);
              }, 500)
            } else {
              this.$notify.success({
                message: `Xóa văn bản "${docName}" thất bại`,
                duration: 3000,
                customClass: "doc-warning",
              });
            }
          } catch (error) {
            this.$notify.success({
              message: `Xóa văn bản "${docName}" thất bại`,
              duration: 3000,
              customClass: "doc-warning",
            });
          }
        })
        .catch(() => {});
    },

    scrollToPosition(index) {
      const element = document.getElementById(`${index}`)
      document.getElementById(`infinite__scroll`).scrollTo({
        top: element.offsetTop >=30 ? element.offsetTop - 10 : element.offsetTop,
        left: 0,
        behavior: "smooth",
      });
    },

    async fn_delete(id) {
      await DocumentApi.delete(id);
      await this.fn_initData();
    },

    formatDateTime(time) {
      return MethodService.formatDate(time, "datetime");
    },

    fn_resetForm() {
      this.$refs["formSearch"].resetFields();
    },

    fn_initDataList(isDelete) {
      if (this.filtersDocument && this.tab == "FILTER") {
        this.dataSearch = MethodService.stringToObject(this.filtersDocument);
        this.countDocFilter = 10;
        this.docFilterOffset = 0;
        this.listDocumentFilterTotal = 0;
        this.listDocumentFilter = [];
        this.fn_getListDocumentFilter();
      } else if (this.tab == "FILTER") {
        this.dataSearch.type = "";
        this.countDocFilter = 10;
        this.docFilterOffset = 0;
        this.listDocumentFilterTotal = 0;
        this.listDocumentFilter = [];
        this.fn_getListDocumentFilter();
      } else if (this.tab == "DOC_IN") {
        this.fn_getListDocumentIn();
      } else if (this.tab == "DOC_OUT") {
        this.fn_getListDocumentOut();
      } else if (this.tab == "DOC_SIGN") {
        this.listDocumentSign = [];
        this.fn_getListDocumentSign(isDelete);
      } else if (this.tab == "DOC_SIGN_CONSENT") {
        this.fn_getListDocumentSignConsent();
      } else if (this.tab == "DOC_SIGN_TEMP") {
        this.fn_getListDocumentSignTemp();
      } else if (this.tab == "DOC_ISSUE") {
        this.fn_getListDocumentIssue();
      } else {
        this.fn_getListOrganizationModelTree();
      }
    },

    async fn_getListOrganizationModelTree() {
      const organizationApiRes = await OrganizationModelApi.list({
        limit: 9999,
      })
      if (organizationApiRes.result) {
        let result = organizationApiRes.result
        let arrEmpIds = []
        result.forEach((item) => {
          if (item.employee_ids) arrEmpIds = arrEmpIds.concat(item.employee_ids)
        })
        arrEmpIds = _.uniq(arrEmpIds)
        await this.getListEmployeeInOrganizationModel(arrEmpIds)
        let treeList = []
        // Get all parent
        let parents = result.filter((r) => {
          return r.parent_id == null
        })
        if (parents != null && parents.length > 0) {
          parents.forEach((organization1) => {
            let obj = {
              id: organization1.id,
              label: organization1.name ? organization1.name : 'Tổ chức không xác định',
              children: [],
            }
            if (organization1.employee_ids && organization1.employee_ids.length > 0) {
              organization1.employee_ids.forEach((empId) => {
                const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find(
                  (e) => e.id == empId
                )
                if (emp) {
                  obj.children.push({
                    // id: emp.id,
                    label: emp.administrative_info.name.full_name,
                    type: 'employee',
                    order: 1,
                    children: [],
                  })
                }
              })
            }
            // Get child of parent
            const childs = result.filter((r) => r.parent_id == obj.id)
            if (childs != null && childs.length > 0) {
              childs.forEach((element) => {
                obj.children.push({
                  id: element.id,
                  label: element.name ? element.name : 'Tổ chức không xác định',
                  order: element.order,
                  type: 'organization',
                  children: this.fn_getTreeByRecursion(element, result),
                })
                if (element.employee_ids && element.employee_ids.length > 0) {
                  element.employee_ids.forEach((empId) => {
                    const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find(
                      (e) => e.id == empId
                    )
                    if (emp) {
                      let updateChild = obj.children.find(e => e.id == element.id)
                      updateChild.children.push({
                        employee_id: emp.id,
                        label: emp.administrative_info.name.full_name,
                        type: 'employee',
                        order: 1,
                        children: [],
                      })
                    }
                  })
                }
              })
              obj.children = obj.children.sort((a, b) => a.order - b.order)
            }
            treeList.push(obj)
          })
        }
        this.mData.dataDefault.listOrganizationModelTree = treeList
        // console.log('DATA', treeList)
      }
    },

    fn_getTreeByRecursion(child, rootArr) {
      let childrenArr = rootArr.filter((r) => r.parent_id == child.id)
      if (!childrenArr || childrenArr.length == 0) return []
      let root = childrenArr.map((organization1) => {
        let obj = {
          id: organization1.id,
          type: 'organization',
          label: organization1.name ? organization1.name : 'Không xác định',
          order: organization1.order,
          children: [],
        }
        ////////////////////////////////
        obj.children = this.fn_getTreeByRecursion(organization1, rootArr)
        if (organization1.employee_ids && organization1.employee_ids.length > 0) {
          organization1.employee_ids.forEach((empId) => {
            const emp = this.mData.dataDefault.listEmployeeInOrganizationModel.find((e) => e.id == empId)
            if (emp) {
              obj.children.push({
                employee_id: emp.id,
                type: 'employee',
                label: emp.administrative_info.name.full_name,
                order: 1,
                children: [],
              })
            }
          })
        }
        return obj
      })
      return root.sort((a, b) => a.order - b.order)
    },
  },

  created() {
    this.fn_getListConTractType();
    this.fn_initDataList()
  },

  watch: {
    filtersDocument(val) {
      if (this.tab == "FILTER") {
        this.dataSearch = MethodService.stringToObject(val);
        this.countDocFilter = 10;
        this.docFilterOffset = 0;
        this.listDocumentFilterTotal = 0;
        this.listDocumentFilter = [];
        this.fn_getListDocumentFilter();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.circle-loading {
  width: 35px;
  height: 35px;
  border-radius: 99rem;
  position: relative;
  margin: 0 auto;
}
.circle-loading:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  border: 4px solid #a7c4d5;
  border-right-color: var(--turquoise);
  animation: circleLoading 1s forwards infinite linear;
}

@keyframes circleLoading {
  to {
    transform: rotate(360deg);
  }
}
.infinite-list-wrapper {
  height: calc(100vh - 230px);
  overflow: auto;
}
.expire {
  padding: 5px 10px;
  border-radius: 4px;
  color: white;
  text-align: center;
  background-color: #7e7e7e;
}
.urgency {
  padding: 5px 10px;
  border-radius: 4px;
  color: white;
  text-align: center;
  &.high-urgency {
    background-color: #f12727;
  }
  &.urgent {
    background-color: #ff5621;
  }
  &.express {
    background: transparent;
    border: 1px solid #ff5621;
    color: #ff5621;
  }
}
.secret {
  padding: 5px 10px;
  border-radius: 4px;
  color: white;
  text-align: center;
  &.top-secret {
    background-color: #f12727;
  }
  &.private {
    background-color: #ff5621;
  }
}
::v-deep .el-tabs__content {
  .el-tab-pane {
    height: calc(100vh - 235px);
    .center-block {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.list {
  list-style: none;

  .list-item {
    height: 140px;
    cursor: pointer;

    &:nth-child(even) {
      .el-card {
        background: #f6f6f6;
      }
    }
    .doc__header-name {
      margin-left: 13px;
      max-width: 75%;
      font-size: 18px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &.unread {
        font-weight: 600;
      }
      &.readed {
        font-weight: 400;
      }
    }
  }
}

::v-deep .el-card {
  border-radius: 0;
  border: none;
  height: 100%;

  &:hover {
    background: #d0e8f5 !important;
  }
  .el-card__body {
    padding: 0 20px 20px 20px;
    .card__item-content {
      height: 45px;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 22px;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      word-break: break-word;
      -webkit-box-orient: vertical;
    }
  }
}
.w-70 {
  width: 70%;
}
.w-30 {
  width: 30%;
}
::v-deep .el-tabs__item {
  border-radius: 0;

  span {
    color: black;
  }
}
::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 3px solid transparent;
    margin: 0;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 0.1px;
      height: 75%;
      background: #7e7e7e;
    }
  }
  .el-tabs__item.is-active {
    border-top: 3px solid var(--orange) !important;
    border-left-color: transparent;

    span {
      color: black;
      font-weight: bold;
    }
  }
}
::v-deep .btn-default.dark-green {
  background: var(--dark-green) !important;
  border: 1px solid var(--dark-green) !important;

  &:focus {
    background: var(--dark-green) !important;
  }

  &:hover {
    background: #15c765 !important;
  }

  &:active {
    background: var(--dark-green) !important;
  }
}
::v-deep .btn-default.dark-blue {
  background: var(--dark-blue) !important;
  border: 1px solid var(--dark-blue) !important;

  &:focus {
    background: var(--dark-blue) !important;
  }

  &:hover {
    background: #438eff !important;
  }

  &:active {
    background: var(--dark-blue) !important;
  }
}
::v-deep .icon {
  font-size: 21px;
  cursor: pointer;
}
.icon24-Foward {
  transition: 0.3s ease;
  &:hover {
    color: var(--turquoise);
    transform: scale(1.1);
  }
  &:active {
    color: var(--black);
  }
  &:focus {
    color: var(--black);
  }
}
::v-deep .isax-trash {
  color: var(--red);
}
::v-deep .isax-eye {
  color: var(--orange);
}
::v-deep .el-upload-dragger {
  height: 36px;
}
::v-deep .el-upload {
  position: relative;
}
::v-deep .el-upload__tip {
  position: absolute;
  top: 5px;
  left: 150px;
  font-style: italic;
  color: #606266;
  margin-top: 0;
}
</style>

<style lang="scss" scoped>
.order {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  &.unread {
    font-weight: 600;
  }
}
.parent__block {
  justify-content: start;
  .first-child__block {
    width: 100%;
    margin-left: 40px;
    .card__item-content {
      font-weight: 300;
      font-size: 15px;
      &.unread {
        font-weight: 600;
      }
    }
    .card__item-annotate {
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 22px;
      -webkit-line-clamp: 1;
      display: -webkit-box;
      word-break: break-all;
      -webkit-box-orient: vertical;
      p {
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
      }
    }
  }
  .second-child__block {
    text-align: left;
    margin-left: 50px;
    flex: 1 0 280px;
    .signer {
      margin-bottom: 5px;
      max-width: 280px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .creator {
      max-width: 280px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .third-child__block {
    margin-left: 50px;
    flex: 1 0 150px;
    .promulgate {
      margin-bottom: 5px;
    }
  }
  .four-child__block {
    text-align: left;
    margin-left: 40px;
    margin-right: 10px;
    flex: 1 0 50px;
  }
}
.text-overflow-custom {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 22px;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  word-break: break-all;
  -webkit-box-orient: vertical;
}
@media (max-width: 1490px) and (min-width: 1191px) {
  .list {
    .list-item {
      .doc__header-name {
        max-width: 75%;
      }
      .el-card__body {
        .parent__block {
          .second-child__block {
            margin-left: 30px;
            flex: 1 0 250px;
            .signer {
              max-width: 250px;
            }
            .creator {
              max-width: 250px;
            }
          }
          .third-child__block {
            margin-left: 30px;
            flex: 1 0 150px;
          }
          .four-child__block {
            margin-left: 20px;
            margin-right: 10px;
            flex: 1 0 30px;
          }
        }
      }
    }
  }
}
@media (max-width: 1190px) and (min-width: 1020px) {
  .list {
    .list-item {
      .doc__header-name {
        max-width: 70%;
      }
      .el-card__body {
        .parent__block {
          .second-child__block {
            margin-left: 30px;
            flex: 1 0 190px;
            .signer {
              max-width: 190px;
            }
            .creator {
              max-width: 190px;
            }
          }
          .third-child__block {
            margin-left: 25px;
            flex: 1 0 150px;
          }
          .four-child__block {
            margin-left: 10px;
            margin-right: 0;
            flex: 1 0 30px;
          }
        }
      }
    }
  }
}
@media (max-width: 1019px) and (min-width: 800px) {
  .list {
    .list-item {
      .doc__header-name {
        max-width: 60%;
      }
      .el-card__body {
        .parent__block {
          .second-child__block {
            margin-left: 25px;
            flex: 1 0 150px;
            .signer {
              max-width: 150px;
            }
            .creator {
              max-width: 150px;
            }
          }
          .third-child__block {
            margin-left: 20px;
            flex: 1 0 150px;
          }
          .four-child__block {
            margin-left: 5px;
            margin-right: 0;
            flex: 1 0 30px;
          }
        }
      }
    }
  }
}
@media (max-width: 799px) and (min-width: 200px) {
  .list {
    .list-item {
      .doc__header-name {
        max-width: 50%;
      }
    }
  }
}
@media (max-width: 799px) {
  .list .list-item { height: auto; }
  .list .list-item ::v-deep .el-card { height: auto; }
  .list .list-item ::v-deep .el-card__body .card__item-content { height: auto; }
  .list .list-item .doc__header-name { max-width: 100%; min-width: 0; overflow-wrap: anywhere; white-space: normal; }
  .list .list-item ::v-deep .el-card__header > div { flex-wrap: wrap; }
  .list .list-item .parent__block { flex-direction: column; gap: 10px; }
  .list .list-item .parent__block > div { width: 100%; min-width: 0; flex: 0 0 auto; margin: 0; }
  .list .list-item .parent__block .signer, .list .list-item .parent__block .creator { max-width: none; white-space: normal; overflow-wrap: anywhere; }
  .list .list-item .parent__block .card__item-content, .list .list-item .parent__block .card__item-annotate, .list .list-item .parent__block .text-overflow-custom { display: block; overflow: visible; white-space: normal; word-break: normal; overflow-wrap: anywhere; -webkit-line-clamp: unset; }
}
</style>
